import React from "react";
var __jsx = React.createElement;
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import ThreeTile from './ThreeTile';
function ThreeTileAdapter(_ref) {
  var entry = _ref.entry;
  var threeTileData = useContentfulLiveUpdates(entry);
  return __jsx(ThreeTile, {
    threeTileData: threeTileData
  });
}
export default ThreeTileAdapter;